// Types accepted: yellow, black, outlined
<template>
  <button
    @click="clicked"
    class="flex items-center justify-center rounded-md px-3 py-3"
    :class="styles"
  >
    <div v-if="isLoading">
      <img
        class="-top-2px loading relative h-6 w-6 w-full"
        src="@/assets/loading-v2-white.svg"
        alt="loading"
      />
    </div>
    <div
      v-else
      :class="[iconLeft ? 'flex flex-row-reverse' : 'flex']"
      class="w-full items-center justify-center"
    >
      <slot />
      <div
        class="h-6 w-6"
        :class="[iconLeft ? 'mr-2' : 'ml-2']"
        v-if="!!iconPath"
      >
        <!-- TODO: Code rafactor is needed in order to use only one tailwind tag for icon size -->
        <img
          class="h-full w-full"
          :src="iconPath"
          alt="icon"
        />
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconPath: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'yellow',
    },
    className: {
      type: String,
      default: '',
    },
    iconLeft: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchable: false,
    };
  },
  computed: {
    styles: function () {
      if (this.disabled) {
        return `${this.disabledStyles} ${this.className}`;
      }
      return `${this.style} ${this.sizes} ${this.search} ${this.className}`;
    },
    style: function () {
      switch (this.variant) {
        case 'yellow':
          return 'text-white bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
        case 'yellow-disabled':
          return 'text-white bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
        case 'black':
          return 'text-white bg-body-color hover:bg-dark-gray active:bg-dark-blue';
        case 'outlined':
          return 'text-gray-over-dark border border-gray-over-dark hover:text-body-color hover:border-body-color active:text-dark-gray active:border-dark-gray';
        case 'transparent':
          return 'text-body-color hover:bg-off-white active:bg-light-gray';
        case 'gray':
          return 'text-gray-over-dark hover:bg-light-gray active:bg-light-gray active:text-body-color';
        case 'space-gray':
          return 'custom-gray text-info-bold-text font-medium hover:opacity-80';
        case 'light-white':
          return 'text-white bg-white bg-opacity-10 hover:bg-opacity-20 active:bg-opacity-30';
        case 'light-yellow':
          return 'text-yellow-500 bg-yellow-500 bg-opacity-20 hover:bg-opacity-30 active:bg-opacity-50';

        default:
          return '';
      }
    },
    disabledStyles: function () {
      switch (this.variant) {
        case 'yellow':
          return 'text-white bg-light-gray ';
        case 'yellow-disabled':
          return 'text-white bg-yellow-500';
        case 'black':
          return 'text-white bg-light-gray ';
        case 'outlined':
          return 'text-light-gray border border-light-gray ';
        case 'transparent':
          return 'text-body-color ';
        case 'light-white':
          return 'text-white bg-white bg-opacity-10 ';
        case 'light-yellow':
          return 'text-yellow-500 bg-yellow-500 bg-opacity-20 ';
        case 'gray':
          return 'opacity-50 text-gray-over-dark cursor-not-allowed';
        default:
          return '';
      }
    },
    sizes: function () {
      switch (this.size) {
        case 'xs':
          return 'w-16 h-8';
        case 'md':
          return 'w-20 h-6';
        case 'lg':
          return 'w-36 h-14';
        case 'xl':
          return 'w-52 h-14';
        default:
          return '';
      }
    },
    search: function () {
      if (this.searchable) {
        return 'flex flex-row align-center justify-between';
      }
      return '';
    },
  },
  methods: {
    clicked: function () {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
  emits: ['click'],
};
</script>
<style scoped>
.custom-gray {
  background-color: rgba(55, 64, 83, 0.1);
}
</style>
